<app-header-style-one></app-header-style-one>
<!-- <div *ngFor="let x of jobsScrollData" class="marquee">
    <marquee behavior="" direction="">{{x.message}}.</marquee>
</div> -->
<!-- <div class="marquee">
    <marquee behavior="scroll" direction="left" scrollamount="6">
         <strong>Job Updates:</strong>
        <span *ngFor="let x of jobsScrollData; let last = last">{{ x.message }} <span *ngIf="!last"> | </span>
        </span>
    </marquee>
</div> -->


<!-- <app-homeone-main-banner></app-homeone-main-banner> -->
<!-- <app-about-page-one></app-about-page-one> -->
<div class="page-title-area" style="padding-top: 8px;padding-bottom: 8px;background: #ba4d13;">
    <div class="container">
        <div class="page-title-content">
            <ul style="margin-bottom: 0px;">
                <li><a routerLink="/" style="text-decoration: none;font-size: 16px;">Home</a></li>
                <li style="text-decoration: none;font-size: 16px;">Profile</li>
            </ul>
            <!-- <h2 style="font-size: 30px;">About Us</h2> -->
        </div>
    </div>
</div>
<!-- <div class="page-title-area item-bg1">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li>&nbsp;</li>
            </ul>
            <h2>&nbsp;</h2>
        </div>
    </div>
</div> -->

<br>
<div class="container">
    <br>

    <ul class="nav-tabset">
        <li class="nav-tab" [ngClass]="{'active': currentTab === 'tab1'}">
            <span class="active" (click)="switchTab($event, 'tab1')">Profile</span>
        </li>
        <li class="nav-tab" [ngClass]="{'active': currentTab === 'tab2'}">
            <span (click)="switchTab($event, 'tab2')">Applied Applications</span>
        </li>

    </ul>
    <div class="tabs-container">
        <div class="pane" id="tab1" *ngIf="currentTab === 'tab1'">
            <mat-card class="cardWithShadow theme-card">
                <h3 style="text-align: center;padding: 18px;">Candidate Details</h3>
                <mat-card-content class="b-t-1">
                    <form [formGroup]="registrationform" #formContainer>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="custom-mat-input-wrapper" style="text-align: center;">
                                    <!-- <label>Upload Picture<span style="color: red;">*</span></label> -->
                                    <input type="file" accept="image/*" #fileInput (change)="onImageChange($event)"
                                        hidden>
                                    <!-- Clickable image that triggers file input -->
                                    <img [src]=" photoPreview ? photoPreview :'assets/img/mepma/profile.png'"
                                        alt="Upload" (click)="fileInput.click()" style="width: 100px; height: 100px; cursor: pointer; border: 2px dashed #ccc;
                                border-radius: 10px; padding: 10px;margin-bottom: 10px;" /><br>
                                    <!-- <span> <strong>Upload Picture<span style="color: red;">*</span></strong> </span> -->
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <label> <strong>Are you SHG/SHG Family Member <span
                                            style="color: red;">*</span></strong></label><br>
                                <div style="display: flex;gap: 18px;margin-top: 16px;">
                                    <label><input type="radio" formControlName="are_you_shg" value="Yes" disabled> SHG
                                        Member</label>
                                    <label><input type="radio" formControlName="are_you_shg" value="No" disabled> SHG
                                        Family
                                        Member</label>
                                </div>

                                <div *ngIf="submittedregist && regist.are_you_shg.errors">
                                    <div *ngIf="regist.are_you_shg.errors" class="errormessage"> Please select Are you
                                        SHG/SHG
                                        Family Member.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-lg-3" style="margin-bottom: 18px;">
                                <label for="">Select District <span style="color: red;">*</span></label>
                                <ng-select (change)="getUlbData($event)" placeholder="Select District"
                                    formControlName="district_id" [readonly]="'true'">
                                    <ng-option value="" selected disabled>Select District</ng-option>
                                    @for (d of districtData; track d.district_id) {
                                    <ng-option [value]="d.district_id">{{ d.district_name }}</ng-option>
                                    }
                                </ng-select>
                                <div *ngIf="submittedregist && regist.district_id.errors">
                                    <div *ngIf="regist.district_id.errors" class="errormessage"> Please Select District.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3" style="margin-bottom: 18px;">
                                <label for="">Select ULB<span style="color: red;">*</span> </label>
                                <ng-select (change)="getSLFdetails($event)" placeholder="Select ULB"
                                    formControlName="ulb_id" [readonly]="'true'">
                                    <ng-option value="" selected disabled>Select ULB</ng-option>
                                    <ng-option [value]="u.ulb_id" *ngFor="let u of ulbData">{{u.ulb_name}}</ng-option>
                                </ng-select>
                                <div *ngIf="submittedregist && regist.ulb_id.errors">
                                    <div *ngIf="regist.ulb_id.errors" class="errormessage"> Please Select ULB.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3" style="margin-bottom: 18px;">
                                <label for="">Select SLF<span style="color: red;">*</span></label>
                                <ng-select placeholder="Select SLF" formControlName="slf_id"
                                    (change)="getShgGropsReport($event)" [readonly]="'true'">
                                    <ng-option value="" selected disabled>Select SLF</ng-option>
                                    <ng-option [value]="s.slf_id" *ngFor="let s of slfData">{{s.slf_name}} -
                                        ({{s.slf_id}})</ng-option>
                                </ng-select>
                                <div *ngIf="submittedregist && regist.slf_id.errors">
                                    <div *ngIf="regist.slf_id.errors" class="errormessage"> Please Select SLF.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3" style="margin-bottom: 18px;">
                                <label for="">Select SHG Group<span style="color: red;">*</span></label>
                                <ng-select placeholder="Select SHG Group" formControlName="shg_id"
                                    (change)="getShgmembersReport($event)" [readonly]="'true'">
                                    <ng-option value="" selected disabled>Select SHG Group</ng-option>
                                    <ng-option [value]="s.shg_group_id"
                                        *ngFor="let s of shgGropsReport">{{s.shg_group_name}} -
                                        ({{s.shg_group_id}})</ng-option>
                                </ng-select>
                                <div *ngIf="submittedregist && regist.shg_id.errors">
                                    <div *ngIf="regist.shg_id.errors" class="errormessage"> Please Select SHG Group.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3" style="margin-bottom: 18px;">
                                <label for="">Select SHG Member <span style="color: red;">*</span></label>
                                <ng-select placeholder="Select Member Id" formControlName="member_id"
                                    (change)="getShgmemberdetails($event)" [readonly]="'true'">
                                    <ng-option value="" selected disabled>Select Member Id</ng-option>
                                    <ng-option [value]="s.member_id"
                                        *ngFor="let s of shgmembersReport">{{s.member_name}} -
                                        ({{s.member_id}})</ng-option>
                                </ng-select>
                                <div *ngIf="submittedregist && regist.member_id.errors">
                                    <div *ngIf="regist.member_id.errors" class="errormessage"> Please Select SHG Member.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3" style="margin-bottom: 18px;"
                                *ngIf="registrationform.get('are_you_shg').value == 'No'">
                                <label for="">Relation with SHG Member <span style="color: red;">*</span></label>
                                <ng-select placeholder="Relation with SHG " formControlName="relation_with_shg"
                                    [readonly]="'true'">
                                    <ng-option value="" selected disabled>Relation with SHG Member </ng-option>
                                    <ng-option [value]="s.name" *ngFor="let s of relationships">{{s.name}}</ng-option>
                                </ng-select>
                                <div *ngIf="submittedregist && regist.relation_with_shg.errors">
                                    <div *ngIf="regist.relation_with_shg.errors" class="errormessage"> Please select
                                        Relation
                                        with SHG Member.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h5>Personal Information</h5>
                        <div class="row">
                            <div class="col-lg-3">
                                <div class="custom-mat-input-wrapper">
                                    <input type="text" class="custom-mat-input" placeholder=" "
                                        formControlName="full_name" appTrimLeadingSpace readonly>
                                    <label>Full Name<span style="color: red;">*</span></label>
                                </div>
                                <div *ngIf="submittedregist && regist.full_name.errors">
                                    <div *ngIf="regist.full_name.errors" class="errormessage"> Please Enter Full Name.
                                    </div>
                                </div>
                            </div>

                            <!-- Father's / Husband's Name -->
                            <div class="col-lg-3">
                                <div class="custom-mat-input-wrapper">
                                    <input type="text" class="custom-mat-input" placeholder=" "
                                        formControlName="father_or_husband_name" appTrimLeadingSpace readonly>
                                    <label>Father’s / Husband’s Name <span style="color: red;">*</span></label>
                                </div>
                                <div *ngIf="submittedregist && regist.father_or_husband_name.errors">
                                    <div *ngIf="regist.father_or_husband_name.errors" class="errormessage"> Please Enter
                                        Father’s / Husband’s Name.
                                    </div>
                                </div>
                            </div>

                            <!-- Date of Birth -->
                            <div class="col-lg-3">
                                <div class="custom-mat-input-wrapper">
                                    <input type="date" class="custom-mat-input" placeholder=" "
                                        formControlName="date_of_birth" [max]="currentdate" readonly>
                                    <label>Date of Birth<span style="color: red;">*</span></label>
                                </div>
                                <div *ngIf="submittedregist && regist.date_of_birth.errors">
                                    <div *ngIf="regist.date_of_birth.errors" class="errormessage"> Please Enter Date of
                                        Birth.
                                    </div>
                                </div>
                            </div>

                            <!-- Gender -->
                            <div class="col-lg-3">
                                <label>Gender<span style="color: red;">*</span></label>
                                <div style="display: flex;gap: 18px;">
                                    <label><input type="radio" formControlName="gender" value="Male" disabled="">
                                        Male</label>
                                    <label><input type="radio" formControlName="gender" value="Female" disabled="">
                                        Female</label>
                                    <label><input type="radio" formControlName="gender" value="Other" disabled="">
                                        Other</label>
                                </div>
                                <div *ngIf="submittedregist && regist.gender.errors">
                                    <div *ngIf="regist.gender.errors" class="errormessage"> Please select gender.
                                    </div>
                                </div>
                            </div>

                            <!-- Contact Number -->
                            <div class="col-lg-3">
                                <div class="custom-mat-input-wrapper">
                                    <input type="text" class="custom-mat-input" placeholder=" "
                                        formControlName="contact_number" maxlength="10"
                                        (input)="newnumaricprevent($event)" appTrimLeadingSpace readonly>
                                    <label>Contact Number<span style="color: red;">*</span></label>
                                </div>
                                <div *ngIf="submittedregist && regist.contact_number.errors">
                                    <div *ngIf="regist.contact_number.errors" class="errormessage"> Please Enter Contact
                                        Number.
                                    </div>
                                </div>
                            </div>

                            <!-- Email ID -->
                            <div class="col-lg-3">
                                <div class="custom-mat-input-wrapper">
                                    <input type="email" class="custom-mat-input" placeholder=" " formControlName="email"
                                        appTrimLeadingSpace readonly>
                                    <label>Email ID<span style="color: red;">*</span></label>
                                </div>
                                <div *ngIf="submittedregist && regist.email.errors">
                                    <div *ngIf="regist.email.errors" class="errormessage"> Please Enter Email ID.
                                    </div>
                                </div>
                            </div>

                            <!-- Aadhaar Number -->
                            <div class="col-lg-3">
                                <div class="custom-mat-input-wrapper">
                                    <input type="text" class="custom-mat-input" placeholder=" "
                                        formControlName="aadhaar_number" maxlength="12"
                                        (input)="newnumaricprevent($event)" appTrimLeadingSpace readonly>
                                    <label>Aadhaar Number<span style="color: red;">*</span></label>
                                </div>
                                <div *ngIf="submittedregist && regist.aadhaar_number.errors">
                                    <div *ngIf="regist.aadhaar_number.errors" class="errormessage"> Please Enter Aadhaar
                                        Number.
                                    </div>
                                </div>
                            </div>

                            <!-- Address -->
                            <div class="col-lg-3">
                                <!-- <div class="custom-mat-input-wrapper"> -->

                                <textarea class="custom-mat-input" rows="1" placeholder="Address*"
                                    formControlName="address" appTrimLeadingSpace style="margin-top: 16px;"
                                    readonly></textarea>
                                <!-- <label>Address<span style="color: red;">*</span></label> -->
                                <!-- </div> -->
                                <div *ngIf="submittedregist && regist.address.errors">
                                    <div *ngIf="regist.address.errors" class="errormessage"> Please Enter Address.
                                    </div>
                                </div>
                            </div>

                        </div>

                        <hr>

                        <!-- Educational Qualification -->
                        <h5>Educational Qualification</h5>
                        <div class="row">
                            <div class="col-lg-4">
                                <!-- <div class="custom-mat-input-wrapper">
                            <input type="text" class="custom-mat-input" placeholder=" "
                                formControlName="highest_qualification">
                            <label>Highest Qualification<span style="color: red;">*</span></label>
                        </div> -->
                                <!-- <label for="">Highest Qualification<span style="color: red;">*</span></label> -->
                                <ng-select placeholder="Highest Qualification" formControlName="highest_qualification"
                                    style="margin-top: 16px;" [readonly]="'true'">
                                    <ng-option value="" selected disabled>Highest Qualification</ng-option>
                                    <ng-option [value]="s.value"
                                        *ngFor="let s of qualifications">{{s.label}}</ng-option>
                                </ng-select>
                                <div *ngIf="submittedregist && regist.highest_qualification.errors">
                                    <div *ngIf="regist.highest_qualification.errors" class="errormessage"> Please select
                                        qualification.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="custom-mat-input-wrapper">
                                    <input type="text" class="custom-mat-input" placeholder=" "
                                        formControlName="year_of_passing" appTrimLeadingSpace readonly>
                                    <label>Year of Passing<span style="color: red;">*</span></label>
                                </div>
                                <div *ngIf="submittedregist && regist.year_of_passing.errors">
                                    <div *ngIf="regist.year_of_passing.errors" class="errormessage"> Please Enter Year
                                        of
                                        Passing.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="custom-mat-input-wrapper">
                                    <input type="text" class="custom-mat-input" placeholder=" "
                                        formControlName="university_or_board" appTrimLeadingSpace readonly>
                                    <label>University / Board<span style="color: red;">*</span></label>
                                </div>
                                <div *ngIf="submittedregist && regist.university_or_board.errors">
                                    <div *ngIf="regist.university_or_board.errors" class="errormessage"> Please Enter
                                        University
                                        / Board.
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr>

                        <!-- Employment Details -->
                        <h5>Employment Details</h5>
                        <div class="row">
                            <div class="col-lg-3">
                                <label>Currently Employed<span style="color: red;">*</span></label>
                                <div style="display: flex;gap: 18px;">
                                    <label><input type="radio" formControlName="currently_employed" value="Yes"
                                            disabled>
                                        Yes</label>
                                    <label><input type="radio" formControlName="currently_employed" value="No" disabled>
                                        No</label>
                                </div>
                                <div *ngIf="submittedregist && regist.currently_employed.errors">
                                    <div *ngIf="regist.currently_employed.errors" class="errormessage"> Please Select
                                        Currently
                                        Employed.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3" *ngIf="registrationform.get('currently_employed').value == 'Yes'">
                                <div class="custom-mat-input-wrapper">
                                    <input type="text" class="custom-mat-input" placeholder=" "
                                        formControlName="work_company_name" appTrimLeadingSpace readonly>
                                    <label>Company Name<span style="color: red;">*</span></label>
                                </div>
                                <div *ngIf="submittedregist && regist.work_company_name.errors">
                                    <div *ngIf="regist.work_company_name.errors" class="errormessage"> Please Enter
                                        Company
                                        Name.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3" *ngIf="registrationform.get('currently_employed').value == 'Yes'">
                                <div class="custom-mat-input-wrapper">
                                    <input type="text" class="custom-mat-input" placeholder=" "
                                        formControlName="designation" appTrimLeadingSpace readonly>
                                    <label>Designation<span style="color: red;">*</span></label>
                                </div>
                                <div *ngIf="submittedregist && regist.designation.errors">
                                    <div *ngIf="regist.designation.errors" class="errormessage"> Please Enter
                                        Designation.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3" *ngIf="registrationform.get('currently_employed').value == 'Yes'">
                                <div class="custom-mat-input-wrapper">
                                    <input type="text" class="custom-mat-input" placeholder=" "
                                        formControlName="work_experience" readonly>
                                    <label>Work Experience (Years)<span style="color: red;">*</span></label>
                                </div>
                                <div *ngIf="submittedregist && regist.work_experience.errors">
                                    <div *ngIf="regist.work_experience.errors" class="errormessage"> Please Enter Work
                                        Experience (Years).
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12" style="text-align: center;margin-top: 18px;">
                                <button class="reg-btn" type="button" (click)="logout()"> Logout </button>
                            </div>
                        </div>

                    </form>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="pane" id="tab2" *ngIf="currentTab === 'tab2'">
            <section class="testimonial-outer padding-lg">
                <div class="tabs-container">
                    <div class="pane" id="tab1">
                        <div class="col-lg-12 col-md-12">
                            <div class="courses-details-desc">

                                <div style="overflow: auto;height: 600px;">
                                    <div class="row">
                                        <ul class="nav-tabset">
                                            <li class="nav-tab">

                                                <div class="searchBar">
                                                    <input id="searchQueryInput" type="text" name="searchQueryInput"
                                                        placeholder="Search" [(ngModel)]="serch" autocomplete="off"
                                                        (keyup)="applyFilter($event)" />
                                                    <button id="searchQuerySubmit" type="submit"
                                                        name="searchQuerySubmit">
                                                        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                                                            <path fill="#fff"
                                                                d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" />
                                                        </svg>
                                                    </button>
                                                </div>


                                            </li>
                                            <!-- <li class="nav-tab">
                                            <div style="margin-bottom: 18px;">
                                                <ng-select placeholder="Select District">
                                                    <ng-option value="" selected disabled>Select District</ng-option>
                                                    <ng-option [value]="d.district_id"
                                                        *ngFor="let d of districtData">{{d.district_name}}</ng-option>
                                                </ng-select>
                                            </div>
                                        </li> -->

                                            <li class="nav-tab" style="float: right;">
                                                <mat-paginator [pageSizeOptions]="[25,50,100]"
                                                    showFirstLastButton></mat-paginator>
                                            </li>
                                        </ul>
                                    </div>
                                    <div>
                                        <table id="table-to-copied" #tab mat-table [dataSource]="dataSource" matSort
                                            multiTemplateDataRows>
                                            <ng-container matColumnDef="i">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    [ngStyle]="headerclass"> S.No
                                                </th>
                                                <td mat-cell *matCellDef="let row;let j = index" class="centre">
                                                    <span class="para"> {{row.i}} </span>
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="district_name">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    [ngStyle]="headerclass">
                                                    District Name
                                                </th>
                                                <td mat-cell *matCellDef="let row"
                                                    style="white-space: nowrap;text-align: left;">

                                                    <span class="para" style="text-align: left;"> {{row.district_name}}
                                                    </span>

                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="mela_date">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    [ngStyle]="headerclass">
                                                    Date
                                                </th>
                                                <td mat-cell *matCellDef="let row">
                                                    <span class="para">
                                                        {{row.mela_date | date:'dd-MM-yyyy'}} </span>
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="mela_name">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    [ngStyle]="headerclass">
                                                    Jobmela
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                    <span class="para"> {{row.mela_name}} </span>

                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="qualification">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    [ngStyle]="headerclass">
                                                    Qualification
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                    <span class="para"> {{row.qualification}} </span>

                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="age_limit">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    [ngStyle]="headerclass">
                                                    Age Limit
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                    <span class="para">
                                                        {{row.age_limit? row.age_limit:'---'}}</span>

                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="payment_date">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    [ngStyle]="headerclass">
                                                    Payment Date
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                    <span class="para"> {{row.payment_date | date:'dd-MM-yyyy'}} </span>

                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="payment_status">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    [ngStyle]="headerclass">
                                                    Payment Status
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                    <span class="para"> {{row.payment_status}}
                                                    </span>

                                                </td>
                                            </ng-container>


                                            <ng-container matColumnDef="action">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    [ngStyle]="headerclass" style="width: 120px;">
                                                    Admit Card
                                                </th>
                                                <td mat-cell *matCellDef="let row" (click)="gotoviewDetails(row)">
                                                    <span class="para" style="cursor: pointer;"><strong>Download
                                                        </strong></span>

                                                </td>
                                            </ng-container>
                                            <!-- Footer start -->
                                            <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
                                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                                                class="example-element-row clickable-row">
                                            </tr>
                                            <tr class="mat-row" *matNoDataRow>
                                                <td class="mat-cell" colspan="7" style="color: red;">No data found</td>
                                            </tr>
                                            <!-- <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"
                                            class="example-detail-row"></tr> -->
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>


<div *ngIf="showloader" class="overlap">
    <div class="loader"></div>
</div>